module.exports = __webpack_public_path__ + "img/mobile-profile-logo-white.f451b90f.svg";